// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { createElement,forwardRef, Ref } from 'react';
import { IconBase, IconProps } from '../icon';

const element = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"g","attrs":{"id":"list-demand"},"children":[{"tag":"path","attrs":{"id":"stroke1","stroke":"props.strokeColor1","d":"M11 5H21M21 10.0001H11M3 15H21M3 20H21","strokeLinecap":"square","strokeWidth":"props.strokeWidth"}},{"tag":"path","attrs":{"id":"stroke2","stroke":"props.strokeColor2","d":"M7 3H3.5C3.22386 3 3 3.22386 3 3.5V6C3 6.27614 3.22386 6.5 3.5 6.5H6.5C6.77614 6.5 7 6.72386 7 7V9.5C7 9.77614 6.77614 10 6.5 10H3","strokeLinecap":"square","strokeWidth":"props.strokeWidth"}}]}]};

const ListDemandIcon = forwardRef<SVGElement, IconProps>((props: IconProps, ref: Ref<SVGElement>) => createElement(
  IconBase,
  {
    ...props,
    id: 'list-demand',
    ref,
    icon: element,
  },
));

ListDemandIcon.displayName = 'ListDemandIcon';

export default ListDemandIcon;
